import React from "react";

import { PrimaryButton } from "../../atoms/Buttons";

import loadIcon from "../../../assets/images/tail-spin.svg";

import { P } from "../../atoms/Texts";
import ModalHolder from "../../molecules/ModalHolder";

const DeleteModal = ({ closeModal, deleting, cta, action, warning, header }) => {
  return (
    <ModalHolder closeModal={closeModal} header={header}>
      <section className="py-4 md:py-6">
        <P className="mb-4">{warning}</P>
        <PrimaryButton.Danger disabled={deleting} onClick={action}>
          {!deleting ? (
            cta
          ) : (
            <img src={loadIcon} alt="Loading" className="mx-auto h-6 w-6" />
          )}
        </PrimaryButton.Danger>
      </section>
    </ModalHolder>
  );
};

export default DeleteModal;
